import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './ChevronArrow.module.scss';

type Props = {
  isOpen: boolean;
  onclick?: () => void;
};

export default function ChevronArrow({ isOpen, onclick }: Props) {
  return (
    <div styleName="arrow" onClick={onclick}>
      {isOpen ? (
        <FontAwesomeIcon icon={faChevronUp} />
      ) : (
        <FontAwesomeIcon icon={faChevronDown} />
      )}
    </div>
  );
}
